var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: { value: _vm.open, title: "Tag Editor" },
      on: { input: _vm.emitClose, hide: _vm.emitClose, show: _vm.emitShow },
    },
    [
      _c("p", [
        _vm._v(
          "Update your tags for this item, new tags (shown darker) will be created for you"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Press enter to create and separate your tags")]),
      _vm._v(" "),
      _c("api-errors", { attrs: { errors: _vm.errors } }),
      _vm._v(" "),
      _c("autocomplete-tags", {
        attrs: {
          "current-tags": _vm.current_tags,
          "user-tags": _vm.userTagsFlat,
        },
        on: { "tag-update": _vm.updateTags },
      }),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-default",
              attrs: { type: "button" },
              on: { click: _vm.emitClose },
            },
            [_vm._v("\n            Close\n        ")]
          ),
          _vm._v(" "),
          _c("submit-tags", {
            attrs: { "submit-url": _vm.submitUrl, tags: _vm.current_tags },
            on: { error: _vm.setErrors, "tags-saved": _vm.updateSavedTags },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }